import React, { createContext, useContext, useState, useEffect } from 'react';

const DemoContext = createContext(null);

export const useDemo = () => {
  const context = useContext(DemoContext);
  if (!context) {
    throw new Error('useDemo must be used within DemoProvider');
  }
  return context;
};

export const DemoProvider = ({ children }) => {
  const [demoMode, setDemoMode] = useState(true);
  const [showAnnotations, setShowAnnotations] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('govspend_demo_mode');
    if (stored !== null) {
      setDemoMode(stored === 'true');
    }
  }, []);

  const toggleDemoMode = () => {
    const newValue = !demoMode;
    setDemoMode(newValue);
    localStorage.setItem('govspend_demo_mode', String(newValue));
  };

  const toggleAnnotations = () => {
    setShowAnnotations(!showAnnotations);
  };

  const value = {
    demoMode,
    showAnnotations,
    toggleDemoMode,
    toggleAnnotations,
  };

  return <DemoContext.Provider value={value}>{children}</DemoContext.Provider>;
};